import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-793b9df8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "profile-nav" }
const _hoisted_3 = { class: "links" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Edit Information")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, "|", -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Save Changes")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_edit_profile_header = _resolveComponent("edit-profile-header")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_default_button = _resolveComponent("default-button")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_ctx.isDataLoaded)
    ? (_openBlock(), _createElementBlock("main", _hoisted_1, [
        _createVNode(_component_edit_profile_header),
        _createElementVNode("section", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_router_link, {
              to: `/edit-profile/${_ctx.selectedProfile.id}`
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["to"]),
            _hoisted_5
          ]),
          _createVNode(_component_default_button, {
            disabled: !_ctx.fieldsEdited,
            onActivate: _ctx.saveChanges
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["disabled", "onActivate"])
        ]),
        _createVNode(_component_router_view, { profile: _ctx.selectedProfile }, null, 8, ["profile"])
      ]))
    : _createCommentVNode("", true)
}